export enum sizeOptions {
  lg = "lg",
  xl = "xl",
}

export enum variantOptions {
  gray = "gray",
}
